const CARDS_TO_SHOW_SMALL = 2.0;
const CARDS_TO_SHOW_MEDIUM = 3.2;
const CARDS_TO_SHOW_LARGE = 3.5;

export const DEFAULT_MAX_SINGLE_IMAGE_HEIGHT = 360;
export const DEFAULT_MAX_SINGLE_IMAGE_WIDTH = 640;

type SingleImageContainerWidthParams = {
	layoutWidth: number;
	windowWidth: number;
	sidePadding: number;
	maxWidth?: number;
};

export const calculateCardsToShow = (width: number) => {
	if (width < 480) {
		return CARDS_TO_SHOW_SMALL;
	}
	if (width < 720) {
		return CARDS_TO_SHOW_MEDIUM;
	}
	return CARDS_TO_SHOW_LARGE;
};

export const getSingleImageContainerWidth = ({
	layoutWidth,
	windowWidth,
	sidePadding,
	maxWidth,
}: SingleImageContainerWidthParams) => {
	const fallbackWidth = windowWidth - sidePadding * 2;
	const availableWidth = layoutWidth > 0 ? layoutWidth : fallbackWidth;

	return typeof maxWidth === "number"
		? Math.min(availableWidth, maxWidth)
		: availableWidth;
};

type SingleImageRenderSizeParams = {
	containerWidth: number;
	aspectRatio: number;
	maxHeight?: number;
	minHeight?: number;
};

export const getSingleImageRenderSize = ({
	containerWidth,
	aspectRatio,
	maxHeight,
	minHeight,
}: SingleImageRenderSizeParams) => {
	const safeAspectRatio = aspectRatio || 1;
	const naturalHeight = containerWidth / safeAspectRatio;
	const cappedHeight =
		typeof maxHeight === "number"
			? Math.min(maxHeight, naturalHeight)
			: naturalHeight;
	const height =
		typeof minHeight === "number"
			? Math.max(minHeight, cappedHeight)
			: cappedHeight;
	const width =
		height < naturalHeight
			? Math.min(containerWidth, height * safeAspectRatio)
			: containerWidth;

	return { width, height };
};
